import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/user-management/create')({
  beforeLoad: () => getTitleContextSlice('Create User'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
